/* Ключ подписки vs ключ провайдера — чистые функции, без DOM на уровне модуля.
 *
 * 🔴 Ротация VAPID-провайдера на сервере молча обнуляет аудиторию: подписки, созданные старым ключом,
 * сервис больше не рассылает (ключ не совпадёт), а приложение на устройстве видит «granted · subscribed»
 * и ничего не подозревает. Единственный способ заметить — сравнить applicationServerKey текущей подписки
 * с тем, что провайдер отдаёт сейчас. Разбор StaySubscribed 2026-10-05: пять устройств молча отвалились. */
/** base64url без паддинга из байтов (ключ подписки хранится как ArrayBuffer). */
export function bytesToBase64url(bytes) {
    const u8 = bytes instanceof ArrayBuffer ? new Uint8Array(bytes) : new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    let bin = "";
    for (let i = 0; i < u8.length; i++)
        bin += String.fromCharCode(u8[i]);
    return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
/** Нормализация ключа для сравнения: base64 → base64url, без паддинга. */
export function normalizeKey(key) {
    return key.trim().replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
/** applicationServerKey подписки в base64url; null — браузер его не отдаёт (старый WebKit) или подписки нет. */
export function subscriptionKey(sub) {
    const k = sub?.options?.applicationServerKey;
    return k ? bytesToBase64url(k) : null;
}
/** Совпадают ли ключи. Когда ключ подписки неизвестен — считаем совпадающим: нет оснований ломать живую подписку. */
export function keyMatches(subKey, providerKey) {
    if (!providerKey || !subKey)
        return true;
    return normalizeKey(subKey) === normalizeKey(providerKey);
}
/** Строка диагностики: match / mismatch / no_sub / no_key — то, что StaySubscribed вывел в сервисный блок. */
export function keyState(subKey, providerKey, hasSub) {
    if (!hasSub)
        return "no_sub";
    if (!providerKey)
        return "no_key";
    return keyMatches(subKey, providerKey) ? "match" : "mismatch";
}
//# sourceMappingURL=pushKey.js.map